import { render, staticRenderFns } from "./showGoods.vue?vue&type=template&id=6f2985e8&scoped=true"
import script from "./showGoods.vue?vue&type=script&lang=js"
export * from "./showGoods.vue?vue&type=script&lang=js"
import style0 from "./showGoods.vue?vue&type=style&index=0&id=6f2985e8&prod&scoped=true&lang=css"
import style1 from "./showGoods.vue?vue&type=style&index=1&id=6f2985e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2985e8",
  null
  
)

export default component.exports